import Phaser from 'phaser';
import { getMyTeam, isPlayerInTeam } from "../../../web3/SFM-TeamsUtils";
import { toast } from 'react-hot-toast';
import { getBalance } from '../../../utils/Helpers';
const playWithTeamOnImgPath = "assets/img/game/PayFeesScene/play-with-team-on.png";
const playWithTeamOffImgPath = "assets/img/game/PayFeesScene/play-with-team-off.png";



export class PayFeesScene extends Phaser.Scene {
    constructor() {
        super({ key: 'PayFeesScene' });
        this.currentMode = 'off';
    }

    create() {
        //check if the current player is in a team
        this.isInTeam = false;
        isPlayerInTeam()
            .then((isInTeam) => {
                if (!this.sys?.isActive()) {
                    return;
                }
                this.isInTeam = isInTeam;
            })
            .catch(() => {
                this.isInTeam = false;
            });
        const x = 0; // X-coordinate of the center of the scene
        const y = (this.game.config.height / 2) + 5; // Y-coordinate of the center of the scene
        const outerDivElement = document.createElement('div');
        outerDivElement.classList.add('d-flex', 'justify-content-center', 'pt-5', 'pb-5', 'mt-5', 'game-container','fix-transition');
        const divElement = document.createElement('div');
        divElement.classList.add('payfees-container'); // Apply the CSS class to the div element
        /////////////////////////////////////////////////////
        const imgElement = document.createElement('img');
        imgElement.src = "assets/img/game/PayGasFees.png";
        imgElement.alt = 'Pay Fees';
        divElement.appendChild(imgElement);
        /////////////////////////////////////////////////////////////////////////
        const iElement = document.createElement('i');
        iElement.classList.add('fas', 'fa-arrow-left');
        iElement.addEventListener('click', this.backFromPaying);
        divElement.appendChild(iElement);
        //////////////////////////////////////////////////////////////////////

        const fuelbtn = document.createElement('div');
        fuelbtn.addEventListener('click', () => this.startGameHandler());
        fuelbtn.style.position = 'absolute';
        fuelbtn.style.top = '320px';
        fuelbtn.style.right = '20px';
        fuelbtn.style.zIndex = '10';
        fuelbtn.style.scale = '0.9';
        const fuelbtnimg = document.createElement('img');
        fuelbtnimg.src = "assets/img/game/PayFeesScene/Fuel Your Spaceship.png";
        fuelbtnimg.alt = 'Fuel your spaceship';
        fuelbtn.appendChild(fuelbtnimg);
        divElement.appendChild(fuelbtn);
        outerDivElement.appendChild(divElement);


        /////////////////////////////////////////////////////

        //create a div to be a container for toggle mode images
        this.toggleModeDiv = document.createElement('div');
        // Add click event listener to toggleModeDiv
        this.toggleModeDiv.addEventListener('click', () => this.toggleMode());
        this.toggleModeDiv.style.position = 'absolute';
        this.toggleModeDiv.style.top = '30px';
        this.toggleModeDiv.style.right = '20px';
        this.toggleModeDiv.style.zIndex = '10';
        this.toggleModeDiv.style.scale = '0.5';

        this.toggleModeDiv.classList.add('toggle-mode-container'); // Apply the CSS class to the toggle mode container div

        //create image element for the on button
        const teamOnBtnImgElement = document.createElement('img');
        teamOnBtnImgElement.src = playWithTeamOnImgPath;
        teamOnBtnImgElement.alt = 'Toggle on play with team';

        //create image element for the off button
        const teamOffBtnImgElement = document.createElement('img');
        teamOffBtnImgElement.src = playWithTeamOffImgPath;
        teamOffBtnImgElement.alt = 'Toggle off play with team';

        //initialize the modes map
        this.modes = {
            'on': teamOnBtnImgElement,
            'off': teamOffBtnImgElement
        };

        //initialize the toggleModeDiv with the on button element
        this.toggleModeDiv.appendChild(this.modes[this.currentMode]);

        //append toggle mode div to the divElement
        divElement.appendChild(this.toggleModeDiv);

        outerDivElement.appendChild(divElement);
        /////////////////////////////////////////////////////////
        this.add.dom(x, y, outerDivElement);
    }
    backFromPaying() {
        // Define the logic for going back from paying
        window.location.reload();
    }

    /**
     * Toggle between team and individual modes
     */
    toggleMode() {
            // Remove the current mode element
            this.toggleModeDiv.removeChild(this.modes[this.currentMode]);

            // Toggle the mode
            this.currentMode = this.currentMode === 'on' ? 'off' : 'on';

            // Append the new mode element
            this.toggleModeDiv.appendChild(this.modes[this.currentMode]);
        }
    async startGameHandler() {
      if (this.currentMode === 'off') {
       const userBalance= await getBalance();
       if(Number(userBalance) >= 0.001){
        this.scene.start('PayFeesScene2', { mode: this.currentMode });
       } else {
          toast.error("You don't have enough balance to start fight");
        }
      } else {//in case user choose team option
        const isPlayerInTeamFlag = await isPlayerInTeam();
        if (isPlayerInTeamFlag) {
          const teamObj = await getMyTeam();
          //pay fees is static for now
          if (parseInt(teamObj.balance) >= 0.001) {
            this.scene.start('PayFeesScene2', { mode: this.currentMode });
          } else {
            toast.error('Your team have no balance to start fight');
          }
        } else {
          toast.error('You must join team first');
        }
      }
    }
}